import React,{Component} from "react"
import { Spin,Card,Button,message, Modal, Row, Col } from "antd";
import Addcard from "./addcard";
import {domainURL,CLOUD_FUNCTION} from "../../../../../config/fbConfig"
import Axios from 'axios';
import {Elements, StripeProvider} from 'react-stripe-elements';
import {stripe_api_key} from "../../../../../config/fbConfig"

export default class Paymentcard extends Component{
    constructor(props){
        super(props)
        this.state={
            isLoading:false,
            cards:[]
        }
    }

    componentWillMount() {
        this.setState({cards:this.props.cards})
    }
    componentWillReceiveProps(nextProps) {
        if(nextProps.auth.removedCardSuccess)
        {this.setState({isLoading:false});
            window.location.reload();
    }
    }
    removeCard=(cardId,carduid)=>{
        var {profile} =this.props;
        this.setState({isLoading:true})
        Axios.post(`${CLOUD_FUNCTION}/api/removeCard`,{cardId,
            customerId:profile.subscription.customerId})
        .then((res)=>{
            if(res.data.deleted){
                var {cards} = this.state;
                cards=cards.filter((card)=>card.uid!==carduid)
                this.setState({cards})
                this.props.removeCard(profile.uid,carduid);
                
        }else{
            message.error("An error has occured")
            console.log(res)
            this.setState({isLoading:false})
        }
        }).catch((err)=>{
            console.log(err)
            message.error("An error has occured. please try again later")
            this.setState({isLoading:false,})
        })
    }

    render(){
        var {profile} = this.props;
        var {cards} = this.state
        return(
            <div>
            <Spin spinning={this.state.isLoading}>
                 <Card
                className="payment-card"
                title={<Row>
                <Col sm={6} lg={12}>
                 Payment Methods
                </Col>
                <Col sm={6} lg={12}>
                <StripeProvider 
                 apiKey={stripe_api_key}
             >
                <Elements>
               <Addcard 
               profile={profile}
               auth={this.props.auth}
               saveCard={this.props.saveCard}
               />
               </Elements>
           </StripeProvider>

               </Col>
            </Row>}
                bordered={false}
                style={{ width: 600 }}
              >
                {cards.map((card)=>(
                <Row style={{marginBottom:"20px"}} key={card.uid}>
                <Col sm={24} lg={20}>
                    <div className="payment-media">
                        <div className="payment-method-img">
                            {card.brand ==="Visa"?
                            <img
                            src="../../img/visa.png"
                            alt="payment method"
                            className="card-img"
                            />:
                            <img
                            src="../../img/mastercard.png"
                            alt="payment method"
                            className="card-img"
                            />
                            } 
                            </div>
                            <div className="payment-method-details">
                                <h4>{card.brand} **** {card.last4}</h4>
                                <p className="payment-method-expiry"> Expires {card.exp_month}/{card.exp_year}</p>
                                <p className="payment-billingAddr"> {card.address_line1}</p>
                            </div>
                        </div>
                      </Col>
                      <Col>
                      <div className="subscription-controls">
                        <Button size="small" onClick={()=>this.removeCard(card.id,card.uid)}>Remove</Button>
                        </div>
                        </Col>
                  </Row>
                ))}
               
              </Card>
            </Spin>
           
            </div>
        )
    }
}
